import { defineStore } from "pinia";

import { useEntityStore } from "@/shared";

import { closeRents as apiCloseRents } from "../api/closeRents";
import { deleteRent } from "../api/deleteRent";
import { deleteRents } from "../api/deleteRents";
import { exportRents } from "../api/exportRents";
import { getRents } from "../api/getRents";
import { reopenRent as apiReopenRent } from "../api/reopenRent";

export const useRentsStore = defineStore("rents", () => {
    const {
        isManyLoading,
        listData,
        meta,
        permissions,
        fetchMany,
        deleteOne,
        deleteMany,
        exportMany,
        setManyLoading,
    } = useEntityStore({
        getEntities: getRents,
        deleteEntity: deleteRent,
        deleteEntities: deleteRents,
        exportEntities: exportRents,
    });

    async function closeRents(rents) {
        await apiCloseRents(rents);
    }

    async function reopenRent(rent) {
        await apiReopenRent(null, rent);
    }

    return {
        listData,
        isManyLoading,
        meta,
        permissions,
        fetchMany,
        deleteOne,
        deleteMany,
        exportMany,
        setManyLoading,
        closeRents,
        reopenRent,
    };
});
